<template>
  <HomeWidgetSmall
    :actionButtonHandler="navigateToActivatedUsers"
    :hasError="hasError"
    :isLoading="isLoading"
    :metric="numUsersWithActivations"
    :widgetType="ScheduledUserActivations"
  />
</template>

<script>
import { ItemTypeConsts, ItemTypeRoutes, StoreModuleMap } from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapState } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import HomeWidgetSmall from 'client/HomePageV2/widgets/HomeWidgetSmall.vue';
import JobApi from 'client/api/v2/JobApi';
import UserStateFilters from 'client/HomePageV2/constants/UserStateFilters';
import Util from 'client/util/Util';

const {
  widgetTypes,
} = HomeWidgetConsts;

const {
  ScheduledUserActivations,
} = widgetTypes;

const {
  description,
  location,
  section,
  toUrl,
  text: textEventProp,
} = eventProperties;

const {
  homePage,
} = eventLocations;

const userDisplayPreferencesModule = StoreModuleMap[ItemTypeConsts.userDisplayPreferences];

export default {
  name: 'ScheduledUserActivationsWidget',

  components: {
    HomeWidgetSmall,
  },

  viewAllRoute: ItemTypeRoutes[ItemTypeConsts.viewScheduledUserActivations],

  data: () => ({
    ScheduledUserActivations,
    hasError: false,
    isLoading: true,
    numUsersWithActivations: 0,
  }),

  computed: {
    ...mapState(userDisplayPreferencesModule, {
      displaySettings: state => state.displayPreferencesData,
    }),

    suspendFilter() {
      return UserStateFilters.state('ACTIVATED', this.displaySettings.scheduledUserActivations?.numberOfDaysToShow);
    },
  },

  created() {
    this.handleCreate();
  },

  methods: {
    ...mapActions(userDisplayPreferencesModule, [
      'fetchDisplayPreferencesData',
    ]),

    async fetchData() {
      return JobApi
        .getUserState(null, null, this.suspendFilter)
        .then(({ totalCount }) => {
          this.numUsersWithActivations = totalCount;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async handleCreate() {
      await this.fetchDisplayPreferencesData();
      await this.fetchData();
    },

    navigateToActivatedUsers() {
      EventHelper.triggerWidgetClicked({
        [description]: 'Schedule User Activation Widget - Home Page',
        [location]: homePage,
        [section]: 'Home Widgets',
        [toUrl]: this.$options.viewAllRoute,
        [textEventProp]: 'Schedule User Activation Widget',
      });
      Util.redirect(this.$options.viewAllRoute);
    },
  },
};
</script>
